/**
 * Pure variant/a11y resolution for the Input primitive (Schicht 1). DOM-free so
 * the contract is unit-testable: `size` → class + `data-size`; `invalid` →
 * `cp-input--invalid` + `aria-invalid` (omitted when valid). Tokens supply the
 * actual colors/spacing via the `cp-input*` classes.
 */
/** Resolve an Input's render props from its style inputs (pure, deterministic). */
export function resolveInputProps(input = {}) {
    const size = input.size ?? "md";
    const invalid = input.invalid ?? false;
    const classes = ["cp-input", `cp-input--${size}`];
    if (invalid)
        classes.push("cp-input--invalid");
    if (input.className)
        classes.push(input.className);
    return {
        className: classes.join(" "),
        "data-size": size,
        "aria-invalid": invalid ? true : undefined,
        disabled: input.disabled ?? false,
    };
}
